import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

export const config = {
  rowSelection: true,
  columns: [
    {
      title: '施工项编码',
      key: 'itemCode',
      dataIndex: 'itemCode',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '施工项名称',
      key: 'itemName',
      dataIndex: 'itemName',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '施工项描述',
      key: 'description',
      dataIndex: 'description',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '适用空间',
      key: 'spaceRefs',
      dataIndex: 'spaceRefs',
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v?.length ? v.map(item => item.spaceName).join('，') : ''),
    },
    {
      title: '适用门店',
      key: 'companyRefs',
      dataIndex: 'companyRefs',
      width: 170,
      ellipsis: {
        showTitle: true,
      },
      render: v => (v?.length ? v.map(item => item.companyName).join('，') : ''),
    },
    {
      title: '状态',
      key: 'enableFlagName',
      dataIndex: 'enableFlagName',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '创建时间',
      key: 'createdTime',
      dataIndex: 'createdTime',
      width: 180,
      itemType: 'dateTime',
    },
    {
      title: (
        <span>
          有效产品数{' '}
          <Tooltip title="指该物料/施工SPU关联的有效的产品SPU个数">
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      ),
      key: 'validProductCount',
      dataIndex: 'validProductCount',
      width: 140,
      render: v => (v?  v : 0),

    },
    {
      title: '已上架分类',
      key: 'prdCategoryName',
      dataIndex: 'prdCategoryName',
      width: 300,
    },
  ],
  search: [
    {
      name: 'orgId',
      label: '适用门店',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      notFoundContent: '请选择适用门店',
      addonOpts: [],
    },
    {
      name: 'itemCode',
      label: '施工项编码',
      itemType: 'input',
      placeholder: '请输入施工项编码',
    },
    {
      name: 'nameKey',
      label: '施工项名称',
      itemType: 'input',
      placeholder: '请输入施工项名称',
    },
    {
      name: 'validProductCount',
      label: '有效产品数',
      itemType: 'custom',
      render: 'numberRender',
      placeholder: '有效产品数',
    },
  ],
  footer: [
    {
      label: '列表数据全选',
      type: 'primary',
      ghost: true,
      events: ['onClick:allSelect'],
    },
  ],
  batchActions: [
    {
      label: '提交到产品库',
      type: 'primary',
      ghost: false,
      events: ['onClick:openCategoryModal'],
    },
  ],
}
